module.exports = __webpack_public_path__ + "3e78c96bc8edc29f6946f242ceaf9860.MP3";